import { createContext, useContext, useReducer } from 'react';
import { CanvasReducer } from '../components/Canvas/state/CanvasReducer';
import { CanvasAction, CanvasState } from '../components/Canvas/state/CanvasState';

export interface CampaignFlowContext {
  state: CanvasState;
  dispatch: (value: CanvasAction) => void;
}

const Context = createContext<CampaignFlowContext>(null);

const useWorkflowContext = (): CampaignFlowContext => {
  const [state, dispatch] = useReducer(CanvasReducer, { nodes: [], edges: [], showIntroVariant: false });

  return {
    state,
    dispatch,
  };
};

function CampaignFlowProvider(props) {
  const value = useWorkflowContext();
  return <Context.Provider value={value} {...props} />;
}

function useWorkFlowCanvas() {
  const context = useContext(Context);

  if (!context) {
    throw new Error(`useCampaignEditorContext must be used within a CampaignEditorProvider`);
  }

  return context;
}

export { CampaignFlowProvider, useWorkFlowCanvas };
